import { createFileRoute } from "@tanstack/react-router";
import ModerationPoliciesListPage from "src/routes/_authed/portal/-components/moderation-policies/ModerationPoliciesListPage";

export const Route = createFileRoute("/_authed/portal/org_{$orgKey}/moderation-policies/")({
  component: ModerationPoliciesListPage,
});
